import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { CenteredPageContent } from '../../components/LayoutComponents'
import { authService } from '@oneblink/apps-react'
import LoadingSpinner from '../../components/LoadingSpinner'

function LogoutScene() {
  console.log('logout scene')
  const history = useHistory()
  const [error, setError] = React.useState<Error | null>(null)
  const redirect = React.useCallback(() => {
    history.replace('/')
  }, [history])

  React.useEffect(() => {
    const abortController = new AbortController()
    const run = async () => {
      try {
        await authService.logout()
        redirect()
      } catch (error) {
        console.warn('Error logging out', error)
        if (!abortController.signal.aborted) {
          setError(error as Error)
        }
      }
    }

    run()

    return () => {
      abortController.abort()
    }
  }, [redirect])

  return (
    <CenteredPageContent>
      {error && (
        <>
          <p>{error.message}</p>
          <button onClick={redirect}>Home</button>
        </>
      )}

      {!error && (
        <LoadingSpinner>
          <span>Logging Out</span>
        </LoadingSpinner>
      )}
    </CenteredPageContent>
  )
}

export default React.memo(LogoutScene)
